import React from "react"
import AsyncCreatableTag from "../../../components/Form/Select/AsyncCreatableTag"
import ArtPieceSharedDetails from "./SharedDetails"
import {
  ART_PIECE_STREET_ART_TAG_TECHNIQUE,
  ART_PIECE_STREET_ART_TAG_TYPE,
  ART_PIECE_STREET_ART_TAG_LEGAL_STATUS,
  ART_PIECE_STREET_ART_TAG_BACKGROUND,
  ART_PIECE_STREET_ART_TAG_MISC,
} from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"

const ArtPieceStreetArt = () => {
  return (
    <div className="scrollable container">
      <div className="row">
        <div className="col-6">
          <h3>Details</h3>
          <ArtPieceSharedDetails />
          <div className="row">
            <div className="col-4">
              <FormInput
                name="streetArt.width"
                validation={{
                  pattern: {
                    value: /^[1-9]\d*(\.\d+)?$/,
                    message: "This field can be only number",
                  },
                }}
                label="Width"
              />
            </div>
            <div className="col-4">
              <FormInput
                name="streetArt.height"
                label="Height"
                validation={{
                  pattern: {
                    value: /^[1-9]\d*(\.\d+)?$/,
                    message: "This field can be only number",
                  },
                }}
              />
            </div>
            <div className="col-4">
              <FormInput
                name="streetArt.length"
                label="Length"
                validation={{
                  pattern: {
                    value: /^[1-9]\d*(\.\d+)?$/,
                    message: "This field can be only number",
                  },
                }}
              />
            </div>
          </div>
          <AsyncCreatableTag
            name="streetArt.type"
            label="Type"
            group={ART_PIECE_STREET_ART_TAG_TYPE}
          />
          <AsyncCreatableTag
            name="streetArt.technique"
            label="Technique"
            group={ART_PIECE_STREET_ART_TAG_TECHNIQUE}
          />
          <AsyncCreatableTag
            name="streetArt.legalStatus"
            label="Legal status"
            group={ART_PIECE_STREET_ART_TAG_LEGAL_STATUS}
          />
          <AsyncCreatableTag
            name="streetArt.background"
            label="Background"
            group={ART_PIECE_STREET_ART_TAG_BACKGROUND}
            placeholder="Building, House, School, Fence..."
          />
          <AsyncCreatableTag
            name="streetArt.miscellaneous"
            label="Miscellaneous"
            group={ART_PIECE_STREET_ART_TAG_MISC}
            placeholder="With permission, Without permission, Wild style, Burner..."
          />

          <FormInput name="streetArt.location" label="Location" />
          <FormInput
            name="streetArt.event"
            label="Event"
            placeholder="E.g. Limited edition, Author print..."
          />
        </div>
        <div className="col-6">
          <h3>Documentary info</h3>
          <FormInput
            name="streetArt.typeOfRecord"
            label={"Type of photo/video record"}
            placeholder={"E.g. digital still image"}
          />
          <FormInput
            name="streetArt.author"
            label="Author"
            placeholder="Who photographed or took a video of the art piece?"
          />
          <FormInput
            name="streetArt.editor"
            label="Editor"
            placeholder="Who edited the photo/video?"
          />
          <FormInput
            name="streetArt.typeOfEditing"
            label="Type Of Editing"
            placeholder="What kind of editing was done?"
          />
        </div>
      </div>
    </div>
  )
}

export default ArtPieceStreetArt
